<template>
  <div class="bg-primary-dark pb-16">
    <header class="bg-primary-dark py-10">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <slot name="header" />
      </div>
    </header>
  </div>
  <main class="-mt-16">
    <div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
      <slot name="content" />
    </div>
  </main>
  <Footer class="mt-16" />
</template>
